<template>
	<WorkIt>
		<Intro
			title="Ellie Mae Blocks"
			subtitle="Design System">
			<p>Inspired by the Atomic Design System and Tilda, a website builder based on blocks of components, we created a system of stackable blocks that is responsive, themed and directly connected to Ellie Mae’s Contentstack CMS.</p>
		</Intro>

		<div class="px14">
			<img class="m-auto mb12 hidden sm:block" src="/img/em-block-system-min.png" srcset="/img/em-block-system@2x-min.png 2x" alt="" />

			<img class="m-auto sm:hidden" src="/img/em-block-system-m-min.png" srcset="/img/em-block-system-m@2x-min.png 2x" alt="" />
		</div>

		<FooterNav prev="/work/ios-android-app" next="/work/websites"></FooterNav>
	</WorkIt>
</template>

<script>
import Intro from '@/components/Intro.vue';
import WorkIt from '@/components/WorkIt.vue';
import FooterNav from '@/components/FooterNav.vue';

import { mapMutations } from 'vuex';

export default {
	components: {
		Intro,
		WorkIt,
		FooterNav
	},
	methods: {
		...mapMutations([
			'APP_CLASS'
		])
	},
	created: function() {
		this.APP_CLASS('page-work work-detail ellie-mae-blocks');
	}
}
</script>